import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SkyaccessApiService } from './skyaccess-api.service';
import { skyaccessData } from './skyaccess-data';



@Injectable({
  providedIn: 'root'
})
export class MockPopulatorService {
  options = {
    _GnSetting: false,
    _ModuleList: false,
    _ModuleList2: false,
    _WelcomePages: false,
    _Businesses: false
  };

  constructor(private skyAPIService: SkyaccessApiService) { }

  checkData(data, field, title){
    if(data == null) {
      (`Null value received for ${title}.`);
      return null;
    }
    else if(Array.isArray(data) && data.length) {
      (`${title} not on Database. Writing Default Values . . .`);
      return this.skyAPIService.createItems(this.modifyToFitDB(this.getMock(field))).pipe(
        map(value => {
          if((value as any)?.Response) this.options[field] = true;
          return value;
        }),
        catchError(error => {
          ('Caught in CatchError. Returning []');
          this.options[field] = false;
          return of([]);     //return from(['A','B','C'])
        })
      );
    } else {
      return data;
    }
  }

  getMock(field){
    if(field === "_WelcomePages") return this.parseWelcomePage();
    else if(field === "_Businesses") return this.parseBusinesses();
    else return skyaccessData[field];
  }

  parseWelcomePage() {
  const modifiedDataset = [];

  Object.keys(skyaccessData._WelcomePages).forEach(key => {
    modifiedDataset.push(skyaccessData._WelcomePages[key]);
  });

  return modifiedDataset;
  }

  parseBusinesses() {
    const modifiedDataset = [];

    skyaccessData._Businesses.Hotel.forEach(element => {
      modifiedDataset.push(element.ItemModule);
      element.Itemlist.forEach(object => {
          object.Items.forEach(item => {
            modifiedDataset.push(item);
          });
      });
  });
  skyaccessData._Businesses.CityGuide.forEach(element => {
    modifiedDataset.push(element.ItemModule);
      element.Itemlist.forEach(object => {
          object.Items.forEach(item => {
            modifiedDataset.push(item);
          });
      });
  });
  return modifiedDataset;
  }

  modifyToFitDB(dataset){
    const templates = [];

    dataset.forEach((design, index) => {
        const defaultData = {
            "_ID": null,
            "_StaticTxt": "",
            "_VarTxt": "",
            "_Color": "",
            "_BgColor": "",
            "PageType": null,
            "EntryType": null,
            "ModuleType": null,
            "Enabled": 0,
            "Links": "",
            "Classes": "",
            "Longitude": "",
            "Latitude": "",
            "StatTranslate": "",
            "FontSz": "",
            "_CreationDate": "",
            "_UpdatedDate": "",
            "FontFam": "Tahoma",
            "High": "",
            "Wdth": "",
            "_Eff": "",
            "_Speed": 100,
            "_Ord": 100,
            "_SysNumber": 111123333
            // "_SysNumber": 286331154
        };
        Object.keys(design).forEach(key => {
            switch (key) {
                case "SkyAccessDesignID":
                    break;
                case "ID":
                case "StaticTxt":
                case "VarTxt":
                case "Color":
                case "BgColor":
                    defaultData['_' + key] = design[key];
                    break;
            
                default:
                    defaultData[key] = design[key];
                    break;
            }
        });
        defaultData['Enabled'] = design['Enabled'] === true ? 1 : 0;
        
        templates.push(defaultData);
        
    });

    return templates;
  }
}
